<div>

  <mat-dialog-content>
    Would you like to complete or reject task {{data.name}}?
  </mat-dialog-content>
  <div mat-dialog-actions>

    <button mat-raised-button mat-button color="primary" class="example-btn-width" (click)="complete(data.id,true)"
      style="cursor:pointer">
      Complete
    </button>

    <button mat-raised-button mat-button color="primary" class="example-btn-width" (click)="complete(data.id,false)"
      style="cursor:pointer">
      Reject
    </button>

    <button mat-raised-button mat-button color="primary" class="example-btn-width"
      (click)="onCloseCancel()">Cancel</button>

  </div>
</div>